// export const extractUniqueAddressComponents = (geocodeResults) => {
//   const seen = new Set();
//   const uniqueComponents = [];

//   geocodeResults.forEach((result) => {
//     result.address_components.forEach((component) => {
//       if (component.types.includes('plus_code')) return;
//       const key = `${component.long_name}|${component.types.join(',')}`;
//       if (!seen.has(key)) {
//         seen.add(key);
//         uniqueComponents.push(component);
//       }
//     });
//   });

//   return uniqueComponents;
// };

export const extractUniqueAddressComponents = (geocodeResults) => {
  const typeMap = {};
  const arabicRegex = /[\u0600-\u06FF]/;

  geocodeResults.forEach((result) => {
    result.address_components.forEach((component) => {
      // Create a key based on types (sorted for consistency)
      const key = component.types.slice().sort().join('|');
      // Prefer English (non-Arabic) long_name for each type
      if (!typeMap[key]) {
        typeMap[key] = component;
      } else if (
        arabicRegex.test(typeMap[key].long_name) && // Existing is Arabic
        !arabicRegex.test(component.long_name) // New is English
      ) {
        typeMap[key] = component;
      }
    });
  });

  // Return the preferred components
  return Object.values(typeMap);
};
